import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import SelectedEvent from '../selectedEvent';
import { Select } from '../../../../components';
import { WarningCircle } from '@phosphor-icons/react';
import { useSelector } from 'react-redux';
import mixpanel from 'mixpanel-browser';

const SubStep2 = ({ updateStep, updateSubStep, setSelectedPlatform, selectedPlatform, error, setError }) => {
  const { userData } = useSelector((state)=>state.app);
  const { eventData } = useSelector((state) => state.sellTickets);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const options = [
    {
      id: 'bms',
      label: 'BookMyShow',
      icon: <img src='assets/images/bms.svg'
        alt='BookMyShow'
        className='w-6 h-6' />,
    },
    // {
    //   id: 'insider',
    //   label: 'Paytm Insider',
    //   icon: <img src='assets/images/insider.svg'
    //     alt='Paytm Insider'
    //     className='w-6 h-6' />,
    // },
    {
      id: 'zomato',
      label: 'District',
      icon: <img src='assets/images/district.png'
        alt='distrct by zomato'
        className='w-6 h-6 rounded-full' />,
    },
  ];

  const handleSelect = (option) => {
    setSelectedPlatform(option);
    setError((prev) => ({ ...prev, default: '' }));
    mixpanel.track("Platform_Selected", {
      "event_id": eventData?._id,
      "event_name": eventData?.name,
      "platform_name": option.label, 
      "user_id": userData?._id|| "Anonymous",
      "page_url": window.location.href,
    });
  };

  const handleBackToStep1 = () => {
    updateStep(1);
    updateSubStep(1);
  };

  return (
    <div className='flex flex-col gap-6 h-full w-full'>
      <Helmet>
        <title>Sell tickets</title>
        <meta
          name="Sell Tickets Easily in India | Reach Your Audience on Take My Tickets"
          content="Start selling your event tickets hassle-free on Take My Tickets, India's trusted ticket resale platform. Add seller contact details effortlessly."
        />
        <meta charset="UTF-8" />
      </Helmet>
      <div className='heading-24 md:heading-36  py-4 md:py-9'> Sell your tickets quickly
        <div className='label-16 text-grey-70 pb-2 pt-6'>Which event are you selling tickets for?</div>
        {eventData && (
          <SelectedEvent event={eventData}
            onBackToStep1={handleBackToStep1} />
        )}
      </div>
      <div className='flex flex-col gap-2'>
        <div className="label-16 pb-2 text-grey-70">
        Which platform did you buy the tickets from?
        </div>
        <div className="flex w-full gap-2 md:flex-row flex-col">
          {options.map((option) => (
            <Select
              key={option.id}
              label={option.label}
              icon={option.icon}
              onClick={() => handleSelect(option)}
              selected={selectedPlatform && selectedPlatform.id === option.id}
              className="w-full platform-select"
            />
          ))}
        </div>
        {error?.default && (
          <div className="text-red-500 label-16 py-2 flex gap-2 items-center">
            <WarningCircle size={26}
              color="#D92D20"
              weight="fill" />
            {error?.default}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubStep2;
